import {
  canPanelAdminTier,
  canPanelManageInterventions,
  canPanelModeratePlayers,
  canPanelSystemCm,
} from './panelRoleAccess';

/**
 * Défauts « code » si aucune ligne BDD (ni individuel, ni rôle) pour la section.
 * CM (rôle 1) : accès large (~90 %), sauf le hub référent global (salon_ref).
 */
export function getCodeDefaultPanelAccess(sectionId: string, roleId: number): boolean {
  if (roleId === 1) {
    return sectionId !== 'salon_ref';
  }

  switch (sectionId) {
    case 'stats':
      return roleId >= 1 && roleId <= 4; // panel équipe (CM, Admin, Modo, GR)
    case 'moderation':
    case 'salon_joueurs':
      return canPanelModeratePlayers(roleId);
    case 'salon_security':
      return canPanelModeratePlayers(roleId);
    case 'interventions':
    case 'interventions_manage':
      return canPanelManageInterventions(roleId);
    case 'player_premium':
    case 'admin':
      return canPanelAdminTier(roleId);
    case 'roles':
      return canPanelAdminTier(roleId);
    case 'system':
    case 'salon_cm':
      return canPanelSystemCm(roleId);
    case 'salon_admin':
      return roleId === 2;
    case 'salon_modo':
      return roleId === 3;
    case 'salon_scenariste':
      return roleId === 4;
    case 'salon_ref':
      return roleId === 4;
    default:
      return false;
  }
}

/** Rôle GR — accès hub référent par défaut (autres : fonction auth_referent). */
export function isReferentTeamRole(roleId: number): boolean {
  return roleId === 4;
}
